import { gql } from '@apollo/client';

export const DELETE_ROTATIONSPLAN = gql`
  mutation mitarbeiter_deleteRotationsplan($rotationsplanId: String!) {
    mitarbeiter_deleteRotationsplan(rotationsplanId: $rotationsplanId) {
      success {
        rotationsplanId
        details
      }
      error {
        message
      }
    }
  }
`;
